import create from "zustand";
import { StateCreator } from "zustand";
import { UniversityInfo } from "../../types/course";

export interface UniversityState {
  uuid: string;
  name: string;
  slug: string;
  color: string;
  logo: string;
  template: string;
  startCourses: any;
  popularCourses: any;
  behaviourId: any;

  setUniversityInfo: (value: UniversityInfo) => void;
  setStartCourses: (value: any) => void;
  setPopularCourses: (value: any) => void;
  setBehaviourId: (value: any) => void;
}

export const UniversitySlice: StateCreator<UniversityState> = (set) => ({
  uuid: "",
  name: "",
  slug: "",
  color: "",
  logo: "",
  template: "",
  startCourses: [],
  popularCourses: [],
  behaviourId: null,

  setUniversityInfo: (value: UniversityInfo) => {
    set({
      uuid: value.uuid,
      name: value.name,
      slug: value.slug,
      color: value.color,
      logo: value.logo,
      template: value.template,
    });
  },
  setStartCourses: (value: any) => {
    set({
      startCourses: value,
    });
  },
  setPopularCourses: (value: any) => {
    set({
      popularCourses: value,
    });
  },
  setBehaviourId: (value: any) => {
    set({
      behaviourId: value,
    });
  },
});
